import script from "./CardUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardUser.vue?vue&type=script&setup=true&lang=ts"

import "./CardUser.vue?vue&type=style&index=0&id=9bf479d8&lang=scss&scoped=true"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf479d8"]])

export default __exports__